// extracted by mini-css-extract-plugin
export default {"scrollableTabshello":"ScrollAbleTabs_scrollableTabshello__aAFnI","tabWrapper":"ScrollAbleTabs_tabWrapper__qsRQF","scrollTabsBar":"ScrollAbleTabs_scrollTabsBar__0yUcS"};